import { render, staticRenderFns } from "./DocumentType.vue?vue&type=template&id=503a3b1e&"
import script from "./DocumentType.vue?vue&type=script&lang=ts&"
export * from "./DocumentType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports